import Countdown from "../containers/countdown";
import pure from "./higher-order/pure";
import React from "react";
import showRaceDate from "../show-race-date";
import { trackListShort } from "../track-list";

export default pure(function TournamentCountdown({ racesForTournament, tournament }) {
  var tracks = trackListShort(racesForTournament);
  var tbd = Object.keys(tracks).length === 0;

  var firstRace = racesForTournament.first();

  return (
    <Countdown date={tournament.get("starts_at")} name="This tournament" tbd={tbd} withDate={showRaceDate(firstRace)} />
  );
});
